import Lookup from './Lookup';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from './Lookup.state';

export default connect(mapStateToProps, mapDispatchToProps)(Lookup);
